import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef, themesRouteRef } from './routes';

export const issuesPlugin = createPlugin({
  id: 'issues',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindIssuesRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(issuesPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceIssuesPage = issuesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceIssuesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-issues", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceThemesPage = issuesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceThemesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-issues", webpackPrefetch: 10 */ './components'
      ).then(m => m.ThemeIndexPage),
    mountPoint: themesRouteRef,
  }),
);
